// Cross-module Edit Task handoff. Several modules (Manager Approval, Developer
// Queue, UI/UX Queue, Kanban, My Day) show the shared TaskDetailModal but do not
// host the task create/edit Dialog themselves — that dialog only lives in the
// Task Table page. Rather than duplicate ~250 lines of form state into every
// module, we drop a tiny handoff token in sessionStorage and let the Task Table
// auto-open its edit dialog on mount. Single source of truth, identical UX.
const KEY = 'taskTableEditHandoff';

export const queueTaskEditHandoff = (taskId) => {
  if (!taskId) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ taskId, ts: Date.now() }));
  } catch (_) {
    // sessionStorage may be unavailable (private mode) — silent no-op,
    // navigation still happens and the user can find the task manually.
  }
};

export const consumeTaskEditHandoff = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const parsed = JSON.parse(raw);
    // Expire stale handoffs (>30s) so a stranded value can't auto-open later.
    if (!parsed?.taskId || Date.now() - (parsed.ts || 0) > 30_000) return null;
    return parsed.taskId;
  } catch (_) {
    return null;
  }
};
